import React from 'react'
import { FeatureComposition } from 'component-library/compositions/FeatureComposition/FeatureComposition'

import { BaseCompositionProps } from '../types'
import { ContentWrapper } from '../ContentWrapper/ContentWrapper'
import { createRegisterableComposition } from 'common/routing/page-definition'
import { ThemeMarginKeys, ContainerWidth } from 'component-library/__styling/settings/metrics'

export interface FeatureCompositionRouteProps extends BaseCompositionProps {
    hasBackgroundFill?: boolean
    /** If true or undefined, will default to the outer margin of the theme */
    horizontalGutters?: boolean | ThemeMarginKeys
    /** If true or undefined, will default to the outer margin of the theme */
    verticalGutters?: boolean | ThemeMarginKeys
    verticalSpacing?: ThemeMarginKeys
    containerWidth?: ContainerWidth
    horizontalGap?: ThemeMarginKeys
}

export const FeatureCompositionRegistration = createRegisterableComposition<
    'main' | 'sidebar' | 'skinny'
>()('feature-composition', (contentAreas, props: FeatureCompositionRouteProps) => (
    <ContentWrapper stretchColumns={props.stretchColumns} stretchSelf={props.stretchSelf}>
        <FeatureComposition
            {...props}
            skinnyContent={contentAreas.skinny}
            mainContent={contentAreas.main}
            sidebarContent={contentAreas.sidebar}
        />
    </ContentWrapper>
))
